export const FACEBOOK = 'Facebook';
export const TWITTER = 'Twitter';
